import PropetyCard from "./PropertyCard";

const MainGallery = (props)=> {
    const db = props.db;
    return <div className="maingallery-container">{
        db.map((item)=> <PropetyCard key={item.id} data={item} db={db}/>)    
    }</div>; 
}

export default MainGallery; 